import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InlineInput } from "@air/component-inline-input";
import { tailwindMerge, tailwindVariants } from "@air/tailwind-variants";
import classNames from "classnames";
import React, { memo, useEffect, useState } from "react";
import { EditableMultilineTextTriggerButton } from "~/_components/InlineInput/EditableMultilineTextTriggerButton";
export const resizableEditableTextInputButton = tailwindVariants({
    base: "h-full w-full text-[length:inherit] leading-[inherit]",
    variants: {
        size: {
            small: "py-1.5",
            medium: "py-2.5"
        }
    },
    defaultVariants: {
        size: "medium"
    }
});
export const resizableEditableInput = tailwindVariants({
    base: "h-full text-[length:inherit] leading-[inherit] text-grey-11 md:text-[length:inherit] md:leading-[inherit]",
    variants: {
        size: {
            small: "py-1",
            medium: "py-2"
        }
    },
    defaultVariants: {
        size: "medium"
    }
});
export const ResizableEditableTextInput = /*#__PURE__*/ memo((param)=>{
    let { disabled = false, onSubmit, defaultValue, appearance, onChange, className, "data-testid": testId, placeholder, size = "medium", label, validate, maxLength, allowNewLines, inputClassName } = param;
    const [isEditing, setIsEditing] = useState(false);
    const [value, setValue] = useState(defaultValue);
    useEffect(()=>{
        setValue(defaultValue);
    }, [
        defaultValue
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: tailwindMerge("relative w-full text-16 md:text-14", isEditing ? "min-w-[130px]" : "", className),
        "data-testid": testId,
        children: [
            /*#__PURE__*/ _jsx(EditableMultilineTextTriggerButton, {
                disabled: disabled,
                placeholder: placeholder,
                appearance: appearance,
                onClick: ()=>setIsEditing(true),
                style: {
                    fontWeight: "inherit"
                },
                className: resizableEditableTextInputButton({
                    size,
                    className: isEditing ? "invisible" : "visible"
                }),
                value: value
            }),
            isEditing && /*#__PURE__*/ _jsx("div", {
                className: classNames("absolute inset-0", appearance === "outline" ? "pt-0.5" : "-mx-px pt-px"),
                children: /*#__PURE__*/ _jsx(InlineInput, {
                    allowNewLines: allowNewLines,
                    label: label,
                    onSubmit: (value)=>{
                        setIsEditing(false);
                        onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(value);
                    },
                    onCancel: ()=>{
                        setValue(defaultValue);
                        setIsEditing(false);
                    },
                    className: "h-full",
                    onChange: (value)=>{
                        setValue(value);
                        onChange === null || onChange === void 0 ? void 0 : onChange(value);
                    },
                    style: {
                        fontWeight: "inherit",
                        overflow: "hidden"
                    },
                    inputClassName: resizableEditableInput({
                        size,
                        className: inputClassName
                    }),
                    defaultValue: value,
                    placeholder: placeholder,
                    validate: validate,
                    maxLength: maxLength
                })
            })
        ]
    });
});
ResizableEditableTextInput.displayName = "ResizableEditableTextInput";
